(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/searchbar-section/searchbar.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/searchbar-section/searchbar.js');

'use strict';

const SearchBarSuggestions = svs.grassroots.components.searchbar_section.SearchBarSuggestions;
const {
  Form,
  Inputv2,
  ControlGroup
} = svs.ui.reactForm;
const {
  ListGroup
} = svs.ui.ReactListGroup;
const {
  ReactIcon
} = svs.ui;
const {
  forwardRef
} = React;
const Searchbar = forwardRef((_ref, ref) => {
  let {
    onSubmit,
    onBlur,
    onChange,
    searchResult,
    searchterm,
    displayResults,
    onClick,
    onKeyDown
  } = _ref;
  return React.createElement("div", {
    ref: ref
  }, React.createElement(Form, {
    className: "grassroots-searchbar-form form-vertical",
    onSubmit: onSubmit
  }, React.createElement(ControlGroup, {
    className: "grassroots-searchbar-form-control-group"
  }, React.createElement(Inputv2, {
    inputHelpText: "S\xF6k f\xF6rening",
    label: "S\xF6k p\xE5 f\xF6rening, idrott, ort eller l\xE4n",
    onBlur: onBlur,
    onChange: onChange,
    placeholder: "S\xF6k p\xE5 f\xF6rening, idrott, ort eller l\xE4n",
    suffix: React.createElement(ReactIcon, {
      icon: "search",
      size: "200"
    }),
    type: "text",
    value: searchterm
  }), displayResults && (searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) > 0 && React.createElement(ListGroup, {
    className: "grassroots-search-suggestions elevation-300 ".concat(svs.grassroots.tenant !== 'sport' && 'u-border-radius-bottom-12')
  }, React.createElement(SearchBarSuggestions, {
    onClick: onClick,
    onKeyDown: onKeyDown,
    searchResult: searchResult
  })))));
});
svs.grassroots.components.searchbar_section.Searchbar = Searchbar;

 })(window);